import React from "react";
import {
  Paper,
  TextField,
  Button,
  Tabs,
  Tab,
  Alert,
  IconButton,
  InputAdornment,
  Box,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { styles } from "./AuthPage.styles";

export default function SignInSignUp({
  handleSubmit,
  activeTab,
  handleTabChange,
  error,
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  handleClickShowPassword,
  handleMouseDownPassword,
  confirmPassword,
  setConfirmPassword,
  showConfirmPassword,
  handleClickShowConfirmPassword,
  loading,
  onForgotPassword,
  onNavigateHome,
}) {
  return (
    <Paper elevation={3} sx={styles.paper}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        centered
        sx={styles.tabs}
      >
        <Tab label="Sign In" />
        <Tab label="Sign Up" />
      </Tabs>

      {error && (
        <Alert severity="error" sx={styles.errorAlert}>
          {error}
        </Alert>
      )}
      <form onSubmit={handleSubmit} style={styles.form}>
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          required
          sx={styles.textField}
          variant="standard"
          InputLabelProps={{
            shrink: true,
          }}
        />

        <TextField
          fullWidth
          label="Password"
          name="password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          required
          sx={styles.textField}
          variant="standard"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {activeTab === 1 && (
          <>
            <TextField
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
              required
              sx={styles.textField}
              variant="standard"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle confirm password visibility"
                      onClick={handleClickShowConfirmPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          sx={styles.submitButton}
          disabled={loading}
        >
          {loading
            ? "Loading..."
            : activeTab === 0
            ? "Sign In"
            : "Create Account"}
        </Button>

        {activeTab === 0 && (
          <Button
            fullWidth
            variant="text"
            onClick={onForgotPassword}
            sx={{ mb: 2 }}
          >
            Forgot Password?
          </Button>
        )}

        <Button
          fullWidth
          variant="text"
          onClick={onNavigateHome}
          sx={{ mb: 2 }}
        >
          ← Landing Page
        </Button>
      </form>
    </Paper>
  );
}
